import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';

import { MgButtonModule } from '@app/src/app/button';
import { MgIconModule } from '@app/src/app/icon';
import { MgOverlayToolsModule } from '@app/src/app/overlay/MgOverlayTools.module';

import { ResolveListUploadErrorsDialogModule } from '@shared/components/XlsListUploader/ResolveListUploadErrorsDialog';
import { XlsListUploaderComponent } from '@shared/components/XlsListUploader/XlsListUploader.component';
import { OverlayModule } from '@shared/components/modal-overlay';
import { TextModule } from '@shared/components/text/text.module';

import { GenericButtonModule } from '../button';
import { SystemAlertModule } from '../system-alert';

@NgModule({
  declarations: [XlsListUploaderComponent],
  imports: [
    // Minga dependencies
    MgButtonModule,
    ResolveListUploadErrorsDialogModule,
    MgOverlayToolsModule,
    MgIconModule,
    OverlayModule,
    TextModule,
    GenericButtonModule,
    SystemAlertModule,

    // External dependencies
    CommonModule,
    FormsModule,
    FlexLayoutModule,
    MatProgressBarModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatSelectModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  exports: [XlsListUploaderComponent],
})
export class XlsListUploaderModule {}
